<template>
  <div
    class="scmcc-logo theme-bg-darkess-color"
    :class="{ mini: type === 'mini' }"
    @click="goHome"
  >
    <!-- <div
      class="image"
      :style="{ backgroundImage: `url(${logoUrl})` }"
      alt="logo"
    ></div> -->
    <img ref="imgDom" v-show="$store.state.main.sidebar.fold" alt="logo" :src = 'logoUrl' class="imgDomMini" @load="loadImage"/>
    <img ref="imgDom" v-show="!$store.state.main.sidebar.fold" alt="logo" :src = 'logoUrl' class="imgDom" @load="loadImage"/>
  </div>
</template>
<script>
import envConst from '../env-const'
import { setTimeout } from 'timers';
export default {
  name: 'logo',
  props: {
    type: String
  },
  mounted(){},
  computed: {
    text() {
      return this.$store.state.app.config.title || '未命名系统'
    },
    logoUrl() {
      if (this.$store.state.main.tenant) {
        return this.type === 'mini'
          ? `${envConst.API_BASE_URL}${this.$store.state.main.tenant.tenantLogoLittle}`
          : `${envConst.API_BASE_URL}${this.$store.state.main.tenant.tenantLogo}`
      } else {
        return ''
      }
    }
  },
  methods: {
    loadImage(){
      console.log("lalalascmcc",this.type)
      let domWidth = document.querySelector('.imgDom').width;
      let domHeight = document.querySelector('.imgDom').height;
       let domWidthMini = document.querySelector('.imgDomMini').width;
      let domHeightMini = document.querySelector('.imgDomMini').height;
      console.log("logoWidth",document.querySelector('.imgDom').width)
      console.log("logoHeight",document.querySelector('.imgDom').height)
      console.log("logoWidthMini",document.querySelector('.imgDomMini').width)
      console.log("logoHeightMini",document.querySelector('.imgDomMini').height)
      let rate = 232/64*1000;
      if(this.$store.state.main.sidebar.fold){
        if(domWidthMini < 64 && domHeightMini < 64) {
            document.querySelector('.imgDomMini').width = domWidthMini;
            document.querySelector('.imgDomMini').height = domHeightMini;
        } else {
          if(domWidthMini>=64 && (+domWidthMini)/(+domHeightMini)*1000>=1000){
            document.querySelector('.imgDomMini').width = 64;
            // document.querySelector('.imgDomMini').height = 64*((+domHeightMini)/(+domWidthMini));
          }else if(domWidthMini>64 && (+domWidthMini)/(+domHeightMini)*1000<1000){
            document.querySelector('.imgDomMini').height = 64;
            // document.querySelector('.imgDomMini').width = 64*((+domWidthMini)/(+domHeightMini));
          }else if((domWidthMini<64 && (+domWidthMini)/(+domHeightMini)*1000>1000)){
            document.querySelector('.imgDomMini').width = 64;
            // document.querySelector('.imgDomMini').height = 64*((+domHeightMini)/(+domWidthMini));
          }else if((domWidthMini<64 && (+domWidthMini)/(+domHeightMini)*1000<1000)){
            document.querySelector('.imgDomMini').height = 64;
            // document.querySelector('.imgDomMini').width = 64*((+domWidthMini)/(+domHeightMini));
          }
        }
      }else{
        if(domWidth < 232 && domHeight < 64) {
            document.querySelector('.imgDom').width = domWidth;
            document.querySelector('.imgDom').height = domHeight;
        } else {
          if(domWidth>232 && (+domWidth)/(+domHeight)*1000>rate){
            document.querySelector('.imgDom').width = 232;
            // document.querySelector('.imgDom').height = 232*((+domHeight)/(+domWidth));
          }else if(domHeight>64 && (+domWidth)/(+domHeight)*1000<rate){
            document.querySelector('.imgDom').height = 64;
            // document.querySelector('.imgDom').width = 64*((+domWidth)/(+domHeight));
          }else if(domHeight<64 && domWidth<232 && (+domWidth)/(+domHeight)*1000<rate){
            document.querySelector('.imgDom').height = 64;
            // document.querySelector('.imgDom').width = 64*((+domWidth)/(+domHeight));
          }else if(domHeight<64 && domWidth<232 && (+domWidth)/(+domHeight)*1000>rate){
            document.querySelector('.imgDom').width = 232;
            // document.querySelector('.imgDom').height = 232*((+domHeight)/(+domWidth));
          }
        }
      }
    },
    goHome() {
      this.$router.push({ name: 'home' })
       console.log("2345",this.$refs.imgDom.style)
       console.log("2345744",document.querySelector('.imgDom').width)
    }
  }
}
</script>

<style lang="stylus">
.scmcc-logo
  display flex
  justify-content center
  align-items center
  width 100%
  height 0
  flex 0 0 64px
  cursor pointer
  user-select none
  overflow hidden

  .image
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    background-size contain
    background-repeat no-repeat
    background-position center

  &.mini
    width 64px
    height 0
    flex 0 0 64px

    .image
      width 32px
</style>
